import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import styles from './introduction.module.scss';

export default memo(function Introduction(props) {
    const { t } = useTranslation(['common', 'wizard']);

    return (
        <div className={styles.container}>
            <div className={styles.informationContainer}>
                <span className={styles.description}>{t('wizard:INTRODUCTION')}</span>
                <span className={styles.description}>{t('wizard:INTRODUCTION_DETAIL')}</span>
                <Button onClick={() => props.changeStep(2)} variant="contained">
                    {t('common:BEGIN')}
                </Button>
            </div>
        </div>
    );
});
